(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-gallery-full-width"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const lightbox = document.getElementById('project-lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxCaption = document.getElementById('lightbox-caption');
  const closeBtn = lightbox.querySelector('.close');
  const nextBtn = lightbox.querySelector('.next');
  const prevBtn = lightbox.querySelector('.prev');
  const triggers = Array.from(document.querySelectorAll('.project-lightbox-trigger'));

  let currentIndex = -1;

  function openLightbox(index) {
    const trigger = triggers[index];
    const fullSrc = trigger.dataset.full;
    const altText = trigger.dataset.alt;
    lightboxImg.src = fullSrc;
    lightboxImg.alt = altText;
    lightboxCaption.textContent = altText;
    lightbox.style.display = 'flex';
    currentIndex = index;
  }

  function closeLightbox() {
    lightbox.style.display = 'none';
    lightboxImg.src = '';
    lightboxCaption.textContent = '';
  }

  function showNext() {
    currentIndex = (currentIndex + 1) % triggers.length;
    openLightbox(currentIndex);
  }

  function showPrev() {
    currentIndex = (currentIndex - 1 + triggers.length) % triggers.length;
    openLightbox(currentIndex);
  }

  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', () => openLightbox(index));
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox(index);
      }
    });
  });

  closeBtn.addEventListener('click', closeLightbox);
  nextBtn.addEventListener('click', showNext);
  prevBtn.addEventListener('click', showPrev);

  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', (e) => {
    if (lightbox.style.display === 'flex') {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') showNext();
      if (e.key === 'ArrowLeft') showPrev();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.testimonialSwiper', {
      loop: true,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 50000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768.98: { slidesPerView: 1 },
        1024.98: { slidesPerView: 2 },
        1320.98: { slidesPerView: 3 },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
